import { render, staticRenderFns } from "./dialogBoxModal.vue?vue&type=template&id=829ff4e4&scoped=true&"
import script from "./dialogBoxModal.vue?vue&type=script&lang=js&"
export * from "./dialogBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./dialogBoxModal.vue?vue&type=style&index=0&id=829ff4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829ff4e4",
  null
  
)

export default component.exports